<section id="project1" class="projects" data-scroll-nav="0">
	<div class="container-fluid">
		<div class="row">
			<div
				class="col-xxl-9 col-xl-10 col-lg-11 col-md-11 col-sm-11 col-11 mx-auto"
			>
				<div class="row">
					<div
						class="col-xl-7 col-md-7 col-sm-6"
						data-aos="fade-up"
						data-aos-duration="2000"
						data-aos-delay="100"
					>
						<div
							class="d-flex flex-column justify-content-center h-100 service-content"
						>
							<div>
								<h1 class="heading">BEYOU</h1>
								<div class="points">
									<p>
										Storebeyou redefines beauty empowerment in the e-commerce
										realm, curating a platform where women's unique beauty takes
										center stage.
									</p>
									<p>
										<a
											class="text-decoration-underline"
											href="#"
											target="_blank"
											>storebeyou.com</a
										>
									</p>
								</div>
							</div>
						</div>
					</div>
					<div class="col-xl-5 col-md-5 col-sm-6">
						<div
							class="d-flex flex-column justify-content-center align-items-sm-end"
						>
							<div class="list-block">
								<h3
									class="mt-0 mb-2"
									data-aos="fade-up"
									data-aos-duration="1000"
									data-aos-delay="100"
								>
									<a href="{{ Url }}/project-details/beyou#branding"
										>Branding</a
									>
								</h3>
								<h3
									class="mt-0 mb-2"
									data-aos="fade-up"
									data-aos-duration="1500"
									data-aos-delay="150"
								>
									<a href="{{ Url }}/project-details/beyou#ui-ux"
										>UI/UX Design</a
									>
								</h3>
								<h3
									class="mt-0 mb-2"
									data-aos="fade-up"
									data-aos-duration="2000"
									data-aos-delay="200"
								>
									<a href="{{ Url }}/project-details/beyou#ecommerce-1"
										>Ecommerce</a
									>
								</h3>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</section>
<section data-scroll-nav="1" class="pb-0">
	<div class="container-fluid p-0">
		<div class="row">
			<div
				class="col-md-12 p-0"
				data-aos="fade-up"
				data-aos-duration="2000"
				data-aos-delay="100"
			>
				<img
					src="{{ baseUrl }}/images/projects/beyou/beyou-banner-min.png"
					alt="rebranding agency dubai"
					width=""
					height=""
					loading="lazy"
				/>
			</div>
		</div>
	</div>
</section>
<section class="section bg-beyou" data-scroll-nav="2">
	<div class="container">
		<div class="row">
			<div
				class="col-xxl-9 col-xl-10 col-lg-11 col-md-11 col-sm-11 col-11 mx-md-0 mx-sm-auto mx-auto"
				data-aos="fade-up"
				data-aos-duration="2000"
				data-aos-delay="100"
			>
				<div class="content">
					<p class="mb-0">
						"Storebeyou faced the challenge of establishing a unique online
						presence in the highly competitive e- commerce landscape for women's
						beauty products. Pixtar took on the task of creating a visually
						appealing and secure platform that resonated with the target
						audience.
					</p>
				</div>
			</div>
		</div>
	</div>
</section>

<section class="bg-beyou branding pb-0" id="branding" data-scroll-nav="3">
	<div class="container">
		<div class="row">
			<div
				class="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-11 col-11 mx-md-0 mx-sm-auto mx-auto"
				data-aos="fade-up"
				data-aos-duration="2000"
				data-aos-delay="100"
			>
				<div class="content">
					<h1 class="heading mb-0">Branding</h1>
					<p>
						Pixtar designed a distinctive logo for Storebeyou, capturing the
						essence of women's beauty and elegance. The logo became a visual
						cornerstone for the brand's identity, radiating sophistication and
						allure.
					</p>
				</div>
			</div>
		</div>
	</div>
</section>

<section class="bg-beyou branding" id="branding1">
	<div class="container-fluid">
		<div class="row">
			<div
				class="col-md-12 p-0"
				data-aos="fade-up"
				data-aos-duration="2000"
				data-aos-delay="100"
			>
				<div class="imglist mb-3">
					<img
						src="{{ baseUrl }}/images/projects/beyou/beyou-branding.png"
						alt="best web design company in dubai"
						width=""
						height=""
						loading="lazy"
					/>
				</div>
			</div>
			<div
				class="col-xxl-10 col-xl-11 col-lg-11 col-md-11 col-sm-11 col-11 mx-auto"
			>
				<div class="row">
					<div
						class="col-xl-6 col-lg-6 col-md-6 mx-lg-auto ps-md-0"
						data-aos="fade-up"
						data-aos-duration="2000"
						data-aos-delay="100"
					>
						<img
							src="{{ baseUrl }}/images/projects/beyou/beyou-model-new.jpg"
							alt="web designing agency dubai"
							width=""
							height=""
							loading="lazy"
						/>
					</div>
					<div
						class="col-xl-6 col-lg-6 col-md-6 ps-md-0"
						data-aos="fade-up"
						data-aos-duration="2000"
						data-aos-delay="100"
					>
						<div class="list">
							<img
								src="{{ baseUrl }}/images/projects/beyou/beyou-bcard.jpg"
								alt="Top branding agency in Dubai"
								width=""
								height=""
								loading="lazy"
							/>
							<img
								src="{{ baseUrl }}/images/projects/beyou/pack.jpg"
								alt="website development company dubai"
								width=""
								height=""
								loading="lazy"
							/>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</section>
<section class="bg-beyou typography" data-scroll-nav="5">
	<div class="container-fluid">
		<div class="row">
			<div
				class="col-xxl-9 col-xl-10 col-lg-11 col-md-11 col-sm-11 col-11 mx-auto"
			>
				<div
					class="typography"
					data-aos="fade-up"
					data-aos-duration="2000"
					data-aos-delay="100"
				>
					<img
						src="{{ baseUrl }}/images/projects/beyou/typography.png"
						alt="best design agency"
						width=""
						height=""
						loading="lazy"
					/>
				</div>
			</div>
		</div>
	</div>
</section>
<section class="section ui-ux" id="ui-ux" data-scroll-nav="8">
	<div class="container-fluid">
		<div class="row">
			<div
				class="col-xxl-9 col-xl-10 col-lg-11 col-md-11 col-sm-11 col-11 mx-auto"
			>
				<div class="row mb-4">
					<div
						class="col-xxl-5 col-xl-6 col-lg-8 col-md-10 col-sm-10"
						data-aos="fade-up"
						data-aos-duration="2000"
						data-aos-delay="100"
					>
						<div class="content">
							<h1 class="heading mb-2">UI/UX Design</h1>
							<p class="">
								Crafted an intuitive and aesthetically pleasing interface for
								the Storebeyou website, ensuring a seamless and engaging user
								experience. The design prioritized showcasing the beauty
								products while facilitating easy navigation for online shoppers.
							</p>
						</div>
					</div>
				</div>
				<div class="row">
					<div
						class="col-lg-9 mx-lg-auto"
						data-aos="fade-up"
						data-aos-duration="2000"
						data-aos-delay="100"
					>
						<video
							class="w-100 h-auto desktopimg"
							id="myVideo3"
							width="320"
							height="176"
							autoplay="true"
							muted="muted"
							loop="true"
							oncanplay="this.play()"
							onloadedmetadata="this.muted = true"
						>
							<source
								src="{{
									baseUrl
								}}/images/projects/beyou/storebeyou-imac-scroll.mp4"
								type="video/mp4"
							/>
							<source
								src="{{
									baseUrl
								}}/images/projects/beyou/storebeyou-imac-scroll.ogg"
								type="video/ogg"
							/>
							Your browser does not support HTML5 video.
						</video>
						<video
							class="w-100 h-auto"
							id="myVideo3"
							width="320"
							height="176"
							autoplay="true"
							muted="muted"
							loop="true"
							oncanplay="this.play()"
							onloadedmetadata="this.muted = true"
						>
							<source
								src="{{ baseUrl }}/images/projects/beyou/storebeyou-laptop.mp4"
								type="video/mp4"
							/>
							<source
								src="{{ baseUrl }}/images/projects/beyou/storebeyou-laptop.ogg"
								type="video/ogg"
							/>
							Your browser does not support HTML5 video.
						</video>
					</div>
				</div>
			</div>
		</div>
	</div>
</section>
<section class="package" id="ecommerce-1" data-scroll-nav="6">
	<div class="container-fluid">
		<div class="row">
			<div
				class="col-xxl-9 col-xl-10 col-lg-11 col-md-11 col-sm-11 col-11 mx-auto"
			>
				<div class="row mb-4">
					<div
						class="col-xxl-5 col-xl-6 col-lg-8 col-md-10 col-sm-10"
						data-aos="fade-up"
						data-aos-duration="2000"
						data-aos-delay="100"
					>
						<div class="content">
							<h1 class="heading mb-2">Ecommerce</h1>
							<p class="">
								Developed the e-commerce platform using Magento, incorporating
								advanced features to enhance the online shopping experience.
								Stringent security measures were implemented to safeguard
								customer data and transactions, fostering trust and reliability.
							</p>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
	<div
		class="col-lg-12 p-0"
		data-aos="fade-up"
		data-aos-duration="2000"
		data-aos-delay="100"
	>
		<!-- <video class="w-100 h-auto" id="myVideo2" width="320" height="176" autoplay="true" muted="muted" loop="true"
			oncanplay="this.play()" onloadedmetadata="this.muted = true">
			<source src="{{baseUrl}}/images/projects/dnour/homescreen.mp4" type="video/mp4">
			<source src="{{baseUrl}}/images/projects/dnour/homescreen.ogg" type="video/ogg">
			Your browser does not support HTML5 video.
		</video> -->
		<img
			src="{{ baseUrl }}/images/projects/beyou/beyou-homescreen.png"
			alt="Top creative agencies in dubai"
			width=""
			height=""
			loading="lazy"
		/>
		<div
			class="owlcarousel1"
			data-aos="fade-up"
			data-aos-duration="2000"
			data-aos-delay="100"
		>
			<owl-carousel-o [options]="desktopslider">
				<ng-container *ngFor="let slide of imageData">
					<ng-template
						class="slide"
						carouselSlide
						[id]="slide.id"
						*ngIf="slide.id <= 3"
					>
						<img
							[src]="slide.url"
							[alt]=""
							[title]=""
							[width]=""
							[height]=""
							loading="lazy"
						/>
					</ng-template>
				</ng-container>
			</owl-carousel-o>
		</div>
		<div
			class="owlcarousel2"
			data-aos="fade-up"
			data-aos-duration="2500"
			data-aos-delay="150"
		>
			<owl-carousel-o [options]="desktopslider1">
				<ng-container *ngFor="let slide of imageData">
					<ng-template
						class="slide"
						carouselSlide
						[id]="slide.id"
						*ngIf="slide.id >= 4 && slide.id <= 6"
					>
						<img
							[src]="slide.url"
							[alt]=""
							[title]=""
							[width]=""
							[height]=""
							loading="lazy"
						/>
					</ng-template>
				</ng-container>
			</owl-carousel-o>
		</div>
		<div class="owlcarousel3">
			<owl-carousel-o
				[options]="desktopslider2"
				data-aos="fade-up"
				data-aos-duration="3000"
				data-aos-delay="200"
			>
				<ng-container *ngFor="let slide of imageData">
					<ng-template
						class="slide"
						carouselSlide
						[id]="slide.id"
						*ngIf="slide.id >= 7 && slide.id <= 9"
					>
						<img
							[src]="slide.url"
							[alt]=""
							[title]=""
							[width]=""
							[height]=""
							loading="lazy"
						/>
					</ng-template>
				</ng-container>
			</owl-carousel-o>
		</div>
	</div>
</section>
<section class="technical" id="technical" data-scroll-nav="8">
	<div class="container">
		<div class="row">
			<div
				class="col-xxl-10 col-xl-10 col-lg-11 col-md-11 col-sm-11 col-11 mx-md-0 mx-sm-auto mx-auto"
			>
				<div class="row mb-4">
					<div
						class="col-xxl-10 col-xl-12 col-lg-12 col-md-12 col-sm-12"
						data-aos="fade-up"
						data-aos-duration="2000"
						data-aos-delay="100"
					>
						<div class="content">
							<p class="mb-md-4 -sm-3 mb-2">
								Storebeyou emerged as a haven for women seeking high-quality
								beauty products tailored to their unique needs. The platform
								aimed to empower women through curated selections that
								celebrated beauty in diversity.
							</p>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</section>
<section
	class="next bg-black pb-0"
	data-aos="fade-up"
	data-aos-duration="2000"
	data-aos-delay="100"
>
	<div class="container">
		<div class="row">
			<div class="col-md-12">
				<div class="next-block">
					<div class="in-line">
						<!-- {{Url}}/project-details/autokoorosh -->
						<a
							href="{{ Url }}/project-details/autokoorosh"
							class="text-white font-bold"
						>
							<img
								src="{{
									baseUrl
								}}/images/projects/autokoorosh/autokoorosh-banner.png"
								alt="web development company dubai"
								width="280"
								height="280"
								loading="lazy"
							/>
							<h1 class="heading text-white">NEXT PROJECT</h1>
						</a>
					</div>
				</div>
			</div>
		</div>
		<div class="line"></div>
	</div>
</section>
